import { getRefundMethodStepRoute } from '@/helpers/refundMethodStep/refundMethodStep'

import { deliveryMethods as deliveryMethodTypes, orderTransactionTypes } from '../constants'
import { getCustomMessageFormatted } from '../helpers'
import routes from '../Router/routes.constants'
import { provinceField } from './constants'

export const getLineItems = items => {
  let newItems = items.map(item => ({ ...item, id: item.id.replace(/-.*/, '') }))
  newItems = newItems.reduce((prev, next) => {
    const index = prev.findIndex(prev => prev.id === next.id)
    const newExchangeFor = next.exchangeInfo ? { exchange_info: next.exchangeInfo } : { ...next.options }

    if (index > -1) {
      prev[index].exchange_for = [...prev[index].exchange_for, newExchangeFor]
    } else {
      prev = [...prev, { ...next, exchange_for: [newExchangeFor] }]
    }

    return prev
  }, [])
  return newItems
}

export const areAllRefundMethodsUnavailable = (allowedRefundMethods = []) => {
  return allowedRefundMethods.length === 0
}

export const isInstantSomeRefundMethod = refundMethods => {
  return refundMethods?.some(rm => rm.is_instant) || false
}

export const getExplanationMessage = type => {
  if (type === 'refund') {
    return 'Indica la dirección (casa/oficina/...) en la que quieres que se recojan los productos a devolver:'
  }

  return 'Indica la dirección (casa/oficina/...) en la que quieres que se recojan los productos a devolver y se te entreguen los nuevos productos escogidos:'
}

export const getNextPage = ({ isExchangeOrMixed, needsExchangeAddress, allowedRefundMethods, refundMethodToApply }) => {
  if (isExchangeOrMixed && needsExchangeAddress) return routes.exchangeAddressPage

  return getRefundMethodStepRoute({ allowedRefundMethods, refundMethodToApply })
}

export const getPhoneNumber = phone => {
  return `+${phone?.prefix} ${phone?.number}`
}

export const getSelectedProvince = ({ provinces, selectedProvinceId }) => {
  if (provinces?.length > 0) {
    return `${provinces?.find(p => p.id === selectedProvinceId)?.name || ''},`
  }
  return ''
}

export const getDeliveryMethodCustomMessage = ({ customMessages, language, deliveryMethodType }) => {
  const message = customMessages?.[language]?.find(msg => msg.key === `delivery_method.${deliveryMethodType}`)?.message
  return getCustomMessageFormatted(message)
}

export const allowsExchangeAddress = deliveryMethod => deliveryMethod?.allows_exchange_address !== false

export const getExchangeAddressFlags = ({ transactionType, deliveryMethod, useSameAddressForExchange }) => {
  const isExchangeOrMixed =
    transactionType === orderTransactionTypes.exchange || transactionType === orderTransactionTypes.mixed
  const deliveryMethodRequiresAddress = deliveryMethod?.requires_address
  const isAddressCollectingMethod =
    deliveryMethod?.type === deliveryMethodTypes.customerPickup ||
    deliveryMethod?.type === deliveryMethodTypes.pickupPoint
  const isExchangeAddressAllowed = allowsExchangeAddress(deliveryMethod)
  const needsExchangeAddress =
    isExchangeAddressAllowed &&
    (!isAddressCollectingMethod || !deliveryMethodRequiresAddress || !useSameAddressForExchange)

  return {
    isExchangeOrMixed,
    deliveryMethodRequiresAddress,
    isAddressCollectingMethod,
    showExchangeAddressCheckbox:
      isExchangeOrMixed && isAddressCollectingMethod && deliveryMethodRequiresAddress && isExchangeAddressAllowed,
    needsExchangeAddress,
  }
}

export const supportsDropOffPointSelection = deliveryMethod => {
  return deliveryMethod?.type === deliveryMethodTypes.pickupPoint && !!deliveryMethod?.carrier_service?.is_pickup_point
}

export const getDistanceLabel = distance => {
  if (distance === null || distance === undefined) return ''

  return `${(distance / 1000).toFixed(1)}km`
}

export const getDropOffPointLocationLabel = dropOffPoint => {
  const street = [dropOffPoint.street, dropOffPoint.house_number].filter(Boolean).join(' ')
  const locality = [dropOffPoint.postal_code, dropOffPoint.city].filter(Boolean).join(' ')
  const location = [street, locality].filter(Boolean).join(', ')
  const distanceLabel = getDistanceLabel(dropOffPoint.distance)

  if (!distanceLabel) return location

  return `${location} - ${distanceLabel}`
}

export const getAddressFieldValue = (address, field, provinceKey) => {
  if (field === provinceField) return address.province?.[provinceKey]

  return address[field]
}

export const replaceShippingAddress = (orderInfo, address) => ({ ...orderInfo, shipping_address: address })
